/* eslint-disable import/prefer-default-export */
/* eslint-disable no-param-reassign */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CancelSessionParams,
  IGenerateSession, GetScheduleParms, ISchedule, ScheduleState,
} from './interface';

export const initialState: ScheduleState = {
  loading: false,
  schedules: [],
  sessionUrl: '',
};

export const scheduleListSlice = createSlice({
  name: 'feature/schedules',
  initialState,
  reducers: {
    getScheduleList(state: ScheduleState, _action: PayloadAction<GetScheduleParms>) {
      state.loading = true;
    },
    getScheduleListSucceeded(state: ScheduleState, action: PayloadAction<ISchedule[]>) {
      state.loading = false;
      state.schedules = action.payload;
    },
    getSessionUrl(state:ScheduleState, _action: PayloadAction<IGenerateSession>) {
      state.loading = true;
    },
    getSessionUrlSuccessed(state:ScheduleState, _action: PayloadAction<string>) {
      state.loading = false;
      state.sessionUrl = _action.payload;
    },
    clearSessionUrl(state:ScheduleState) {
      state.sessionUrl = '';
    },
    getScheduleListFailed(state: ScheduleState) {
      state.loading = false;
    },
    getSessionUrlFailed(state: ScheduleState) {
      state.loading = false;
    },
    cancelSession(state: ScheduleState, _action: PayloadAction<CancelSessionParams>) {
      state.loading = true;
    },
    cancelSessionSuccess(state: ScheduleState) {
      state.loading = false;
    },
    cancelSessionFailed(state: ScheduleState) {
      state.loading = false;
    },
  },
});

export const { actions: schedulesActions } = scheduleListSlice;
